<script setup>
defineProps({
  summary: {
    type: Object,
    required: true,
  },
});

const getSentimentColor = sentiment => {
  const colors = {
    positive: 'text-g-500 bg-g-50 dark:bg-g-900/20',
    negative: 'text-r-500 bg-r-50 dark:bg-r-900/20',
    neutral: 'text-n-slate-11 bg-n-solid-3',
  };
  return colors[sentiment] || colors.neutral;
};

const getSentimentIcon = sentiment => {
  const icons = {
    positive: 'i-lucide-smile',
    negative: 'i-lucide-frown',
    neutral: 'i-lucide-meh',
  };
  return icons[sentiment] || icons.neutral;
};
</script>

<template>
  <div class="rounded-lg bg-n-solid-2 p-4">
    <div class="flex items-center justify-between mb-3">
      <h4
        class="text-xs font-semibold text-n-slate-11 uppercase tracking-wider"
      >
        {{ $t('AGENTS_SIDECAR.SUMMARY.TITLE') }}
      </h4>
      <div
        v-if="summary.sentiment"
        class="flex items-center gap-1.5 px-2 py-1 rounded-full text-xs font-medium"
        :class="getSentimentColor(summary.sentiment)"
      >
        <span :class="getSentimentIcon(summary.sentiment)" />
        <span class="capitalize">{{ summary.sentiment }}</span>
      </div>
    </div>

    <p class="text-n-slate-12 leading-relaxed">
      {{ summary.text }}
    </p>

    <div v-if="summary.intent" class="mt-3 flex items-center gap-2">
      <span class="text-xs text-n-slate-10">
        {{ $t('AGENTS_SIDECAR.SUMMARY.INTENT') }}:
      </span>
      <span
        class="px-2 py-0.5 text-xs font-medium rounded-full bg-n-alpha-3 text-n-slate-12"
      >
        {{ summary.intent }}
      </span>
    </div>

    <div v-if="summary.keyPoints?.length" class="mt-3">
      <p class="text-xs text-n-slate-10 mb-2">
        {{ $t('AGENTS_SIDECAR.SUMMARY.KEY_POINTS') }}:
      </p>
      <ul class="space-y-1">
        <li
          v-for="(point, index) in summary.keyPoints"
          :key="index"
          class="flex items-start gap-2 text-sm text-n-slate-11"
        >
          <span class="i-lucide-check text-g-500 mt-0.5 flex-shrink-0" />
          <span>{{ point }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
